import { css } from 'lit'

export default css`
    legend {
        padding: 0;
        display: table;
    }
    fieldset {
        border: 0;
        padding: 0.01em 0 0 0;
        margin: 0;
        min-width: 0;
    }
    body:not(:-moz-handler-blocked) fieldset {
        display: table-cell;
    }

    zaptic-radio:first-child {
        margin-top: 0;
    }
    zaptic-radio {
        display: block;
    }
`
